<template>
  <div class="gerenyushouruxinxi-layer">
    <!-- 标题区域 -->
    <div class="header-section">
      <h2 class="page-title">个人收入信息</h2>
      <p class="page-subtitle">请填写您的收入信息，用于信用风险评估</p>
    </div>

    <!-- 主要内容区域 -->
    <div class="content-container">
      <!-- 个人信息表单 -->
      <div class="form-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>个人信息</h3>
        </div>

        <div class="form-grid">
          <!-- 姓名 -->
          <div class="form-item">
            <label class="form-label">姓名</label>
            <el-input v-model="personInfo.name" placeholder="请输入姓名" class="income-input">
            </el-input>
          </div>

          <!-- 身份证号 -->
          <div class="form-item">
            <label class="form-label">身份证号</label>
            <el-input 
              v-model="personInfo.idCard" 
              placeholder="请输入身份证号" 
              class="income-input"
              :maxlength="18"
              @blur="validateIdCard">
            </el-input>
          </div>

          <!-- 职业 -->
          <div class="form-item">
            <label class="form-label">职业</label>
            <el-select v-model="personInfo.job" placeholder="请选择职业" class="income-select">
              <el-option label="党的机关、国家机关、群众团体和社会组织、企事业单位负责人" value="党的机关、国家机关、群众团体和社会组织、企事业单位负责人"></el-option>
              <el-option label="专业技术人员" value="专业技术人员"></el-option>
              <el-option label="办事人员和有关人员" value="办事人员和有关人员"></el-option>
              <el-option label="社区生产服务和生活服务人员" value="社区生产服务和生活服务人员"></el-option>
              <el-option label="农、林、牧、渔业生产及辅助人员" value="农、林、牧、渔业生产及辅助人员"></el-option>
              <el-option label="生产制造及有关人员" value="生产制造及有关人员"></el-option>
              <el-option label="军人" value="军人"></el-option>
              <el-option label="不便分类的其他从业人员" value="不便分类的其他从业人员"></el-option>
            </el-select>
          </div>

          <!-- 从业年限 -->
          <div class="form-item">
            <label class="form-label">从业年限</label>
            <el-input 
              v-model="personInfo.workYears" 
              placeholder="请输入从业年限" 
              class="income-input"
              @input="validateWorkYears"
              :maxlength="2">
              <template slot="append">年</template>
            </el-input>
          </div>

          <!--单位名称-->
          <div class="form-item">
            <label class="form-label">单位名称</label>
            <el-input v-model="personInfo.companyName" placeholder="请输入单位名称" class="income-input">
            </el-input>
          </div>
        </div>
      </div>
      <!-- 收入信息表单 -->
      <div class="form-section">
        <div class="section-title">
          <span class="title-icon"></span>
          <h3>收入详情</h3>
        </div>

        <div class="form-grid">
          <!-- 月收入 -->
          <div class="form-item">
            <label class="form-label">月收入（元）</label>
            <el-input 
              v-model="personInfo.monthlyIncome" 
              placeholder="请输入月收入" 
              class="income-input"
              @input="validateNumberInput('monthlyIncome')">
              <template slot="append">元</template>
            </el-input>
          </div>

          <!-- 收入来源 -->
          <div class="form-item">
            <label class="form-label">收入来源</label>
            <el-select v-model="personInfo.incomeSource" placeholder="请选择收入来源" class="income-select">
              <el-option label="工资" value="工资"></el-option>
              <el-option label="理财" value="理财"></el-option>
              <el-option label="分红" value="分红"></el-option>
              <el-option label="其它" value="其它"></el-option>
            </el-select>
          </div>

          <!-- 月支出 -->
          <div class="form-item">
            <label class="form-label">月支出（元）</label>
            <el-input 
              v-model="personInfo.monthlyExpense" 
              placeholder="请输入月支出" 
              class="income-input"
              @input="validateNumberInput('monthlyExpense')">
              <template slot="append">元</template>
            </el-input>
          </div>

          <!-- 社保缴纳 -->
          <div class="form-item">
            <label class="form-label">社保缴纳</label>
            <el-select v-model="personInfo.socialSecurity" placeholder="请选择是否缴纳社保">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </div>

          <!-- 公积金缴纳 -->
          <div class="form-item">
            <label class="form-label">公积金缴纳</label>
            <el-select v-model="personInfo.accumulatedFund" placeholder="请选择是否缴纳公积金">
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select>
          </div>

          <!-- 婚姻状况-->
          <div class="form-item">
            <label class="form-label">婚姻状况</label>
            <el-select v-model="personInfo.maritalStatus" placeholder="请选择婚姻状况">
              <el-option label="已婚" value="已婚"></el-option>
              <el-option label="未婚" value="未婚"></el-option>
            </el-select>
          </div>

        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="action-section">
        <el-button type="primary" class="submit-btn" @click="handleSubmit">
          下一步
        </el-button>
        <el-button class="reset-btn" @click="handleReset">
          重置
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gerenyushouruxinxi',
  components: {},
  props: {},
  data () {
    return {
      personInfo: {
        name: '',
        idCard: '',
        job: '',
        workYears: '',
        companyName: '',

        monthlyIncome: '',
        monthlyExpense: '',
        socialSecurity: '',
        accumulatedFund: '',
        maritalStatus: '',
        incomeSource: '',
      },
    }
  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {
    // 初始化数据
    this.initData();
  },
  methods: {
    // 初始化数据
    initData () {
      // 可以在这里加载已有数据
      let existingData = sessionStorage.getItem('personInfo');
      if (existingData) {
        this.personInfo = JSON.parse(existingData);
      }
    },

    // 验证从业年限（只能输入正整数）
    validateWorkYears(value) {
      // 移除非数字字符
      let cleanValue = value.replace(/[^0-9]/g, '');
      
      // 限制在合理范围内（1-50年）
      if (cleanValue) {
        const numValue = parseInt(cleanValue);
        if (numValue > 50) {
          cleanValue = '50';
        } else if (numValue < 1 && cleanValue !== '0') {
          cleanValue = '';
        } else if (numValue === 0) {
          cleanValue = '';
        }
      }
      
      // 更新模型值
      this.$nextTick(() => {
        this.personInfo.workYears = cleanValue;
      });
    },
    
    // 验证数字输入（用于收入、支出等金额字段）
    validateNumberInput(field) {
      let value = this.personInfo[field];
      
      // 移除非数字字符（保留小数点）
      let cleanValue = value.replace(/[^0-9.]/g, '');
      
      // 确保只有一个小数点
      const parts = cleanValue.split('.');
      if (parts.length > 2) {
        cleanValue = parts[0] + '.' + parts.slice(1).join('');
      }
      
      // 限制小数位数（最多2位）
      if (parts.length === 2 && parts[1].length > 2) {
        cleanValue = parts[0] + '.' + parts[1].substring(0, 2);
      }
      
      // 限制最大值（99999999）
      if (cleanValue && parseFloat(cleanValue) > 99999999) {
        cleanValue = '99999999';
      }
      
      // 更新模型值
      this.$nextTick(() => {
        this.personInfo[field] = cleanValue;
      });
    },
    // 验证身份证号
    validateIdCard() {
      const idCard = this.personInfo.idCard;
      if (!idCard) {
        this.$message({
          message: '请输入身份证号',
          type: 'warning'
        });
        return false;
      }
      
      // 身份证号正则表达式（18位）
      const idCardRegex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      
      if (!idCardRegex.test(idCard)) {
        this.$message({
          message: '请输入正确的身份证号格式',
          type: 'error'
        });
        return false;
      }
      
      // 验证最后一位校验码
      if (!this.verifyIdCardChecksum(idCard)) {
        this.$message({
          message: '身份证号校验码错误',
          type: 'error'
        });
        return false;
      }
      
      return true;
    },
    
    // 验证身份证号校验码
    verifyIdCardChecksum(idCard) {
      const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
      
      let sum = 0;
      for (let i = 0; i < 17; i++) {
        sum += parseInt(idCard[i]) * weights[i];
      }
      
      const checkCode = checkCodes[sum % 11];
      return idCard[17].toUpperCase() === checkCode;
    },
    
    // 验证从业年限（只能输入正整数）
    validateWorkYears(value) {
      // 移除非数字字符
      let cleanValue = value.replace(/[^0-9]/g, '');
      
      // 限制在合理范围内（1-50年）
      if (cleanValue) {
        const numValue = parseInt(cleanValue);
        if (numValue > 50) {
          cleanValue = '50';
        } else if (numValue < 1 && cleanValue !== '0') {
          cleanValue = '';
        } else if (numValue === 0) {
          cleanValue = '';
        }
      }
      
      // 更新模型值
      this.$nextTick(() => {
        this.personInfo.workYears = cleanValue;
      });
    },
    // 计算年龄
    calculateAge(idCard) {
      const birthDate = idCard.substring(6, 14);
      const year = parseInt(birthDate.substring(0, 4));
      const month = parseInt(birthDate.substring(4, 6));
      const day = parseInt(birthDate.substring(6, 8));
      const today = new Date();
      const age = today.getFullYear() - year - (today.getMonth() < month - 1 || (today.getMonth() === month - 1 && today.getDate() < day) ? 1 : 0);
      return age;
    },
    handleSubmit () {
      // 表单验证
      if (!this.validateForm()) {
        return;
      }
      
      const formData = {
        name: this.personInfo.name,
        idCard: this.personInfo.idCard,
        age: this.calculateAge(this.personInfo.idCard),
        job: this.personInfo.job,
        workYears: this.personInfo.workYears,
        companyName: this.personInfo.companyName,
        monthlyIncome: this.personInfo.monthlyIncome,
        monthlyExpense: this.personInfo.monthlyExpense,
        socialSecurity: this.personInfo.socialSecurity,
        accumulatedFund: this.personInfo.accumulatedFund,
        maritalStatus: this.personInfo.maritalStatus,
        incomeSource: this.personInfo.incomeSource,
      };
      sessionStorage.setItem('personInfo', JSON.stringify(formData));
      console.log('提交的收入信息:', formData);

      this.$message({
        message: '收入信息提交成功！',
        type: 'success'
      });
      this.$emit('nextStep', 'daikuanxinxi');
    },
    
    // 表单验证
    validateForm() {
      // 验证身份证号
      if (!this.validateIdCard()) {
        return false;
      }
      
      // 验证从业年限
      if (!this.personInfo.workYears) {
        this.$message.warning('请输入从业年限');
        return false;
      }
      
      const workYears = parseInt(this.personInfo.workYears);
      if (workYears < 1 || workYears > 50) {
        this.$message.warning('从业年限应在1-50年之间');
        return false;
      }
      
      // 验证月收入
      if (!this.personInfo.monthlyIncome) {
        this.$message.warning('请输入月收入');
        return false;
      }
      
      const monthlyIncome = parseFloat(this.personInfo.monthlyIncome);
      if (monthlyIncome <= 0 || monthlyIncome > 99999999) {
        this.$message.warning('请输入有效的月收入金额');
        return false;
      }
      
      // 验证月支出
      if (!this.personInfo.monthlyExpense) {
        this.$message.warning('请输入月支出');
        return false;
      }
      
      const monthlyExpense = parseFloat(this.personInfo.monthlyExpense);
      if (monthlyExpense < 0 || monthlyExpense > 99999999) {
        this.$message.warning('请输入有效的月支出金额');
        return false;
      }
      
      // 验证支出不超过收入
      if (monthlyExpense > monthlyIncome) {
        this.$message.warning('月支出不应超过月收入');
        return false;
      }
      
      // 验证其他必填字段
      const requiredFields = [
        { field: 'name', message: '请输入姓名' },
        { field: 'job', message: '请选择职业' },
        { field: 'companyName', message: '请输入单位名称' },
        { field: 'incomeSource', message: '请选择收入来源' },
        { field: 'socialSecurity', message: '请选择社保缴纳情况' },
        { field: 'accumulatedFund', message: '请选择公积金缴纳情况' },
        { field: 'maritalStatus', message: '请选择婚姻状况' }
      ];
      
      for (let item of requiredFields) {
        if (!this.personInfo[item.field]) {
          this.$message.warning(item.message);
          return false;
        }
      }
      
      return true;
    },

    // 重置信息
    handleReset () {
      this.personInfo.name = '';
      this.personInfo.idCard = '';
      this.personInfo.job = '';
      this.personInfo.workYears = '';
      this.personInfo.companyName = '';
      this.personInfo.monthlyIncome = '';
      this.personInfo.monthlyExpense = '';
      this.personInfo.socialSecurity = '';
      this.personInfo.accumulatedFund = '';
      this.personInfo.maritalStatus = '';
      this.personInfo.incomeSource = '';

      sessionStorage.removeItem('personInfo');
      this.$message({
        message: '信息已重置',
        type: 'info'
      });
    }
  }
}
</script>

<style scoped lang="less">
.gerenyushouruxinxi-layer {
  height: 100%;
  // padding: 20px;
  box-sizing: border-box;
  color: #fff;
}

// 标题区域
.header-section {
  text-align: center;
  margin-bottom: 30px;

  .page-title {
    font-size: 28px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 10px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .page-subtitle {
    font-size: 14px;
    color: #b8c4e0;
    margin: 0;
  }
}

// 内容容器
.content-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

// 区块通用样式
.form-section,
.assessment-section {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  border: 1px solid rgba(21, 73, 243, 0.2);
  padding: 25px;
  backdrop-filter: blur(10px);
}

// 区块标题
.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;

  .title-icon {
    width: 4px;
    height: 20px;
    background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
    border-radius: 2px;
  }

  h3 {
    font-size: 18px;
    color: #fff;
    margin: 0;
    font-weight: 600;
  }
}

// 表单网格
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

// 表单项
.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .form-label {
    font-size: 14px;
    color: #b8c4e0;
    font-weight: 500;
  }
}

// 输入框样式
.income-input {
  /deep/.el-input__inner {
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #fff;
    font-size: 14px;

    &::placeholder {
      color: rgba(184, 196, 224, 0.6);
    }

    &:focus {
      border-color: #1549F3;
      box-shadow: 0 0 0 2px rgba(21, 73, 243, 0.2);
    }
  }

  /deep/.el-input-group__append {
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-left: none;
    color: #b8c4e0;
    border-radius: 0 8px 8px 0;
  }
}

// 选择框样式
.income-select {
  /deep/.el-input__inner {
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #fff;
    font-size: 14px;

    &:focus {
      border-color: #1549F3;
      box-shadow: 0 0 0 2px rgba(21, 73, 243, 0.2);
    }
  }

  /deep/.el-select-dropdown {
    background: rgba(0, 18, 64, 0.95);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
  }

  /deep/.el-select-dropdown__item {
    color: #b8c4e0;

    &:hover {
      background: rgba(21, 73, 243, 0.2);
    }

    &.selected {
      color: #fff;
      background: rgba(21, 73, 243, 0.3);
    }
  }
}

// 操作区域
.action-section {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;

  .submit-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
    border: none;
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);
    }
  }

  .reset-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #b8c4e0;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(21, 73, 243, 0.2);
      color: #fff;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .content-container {
    padding: 0 10px;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .action-section {
    flex-direction: column;
    align-items: center;

    .submit-btn,
    .reset-btn {
      width: 200px;
    }
  }
}
</style>
